import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSession } from '@/domains/auth/services/auth.service';
import { fetchCompanyProfile } from '@/domains/company/services/company.service';
import { resolveEntityDashboardPath } from '@/domains/company/constants/entity.config';
import { getEntityType, saveEntityType } from '@/domains/company/utils/entitySession';
import { handleErrorApi } from '@/utils/handleErrorApi';

export default function CompanyDashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const session = getSession();
    if (!session) {
      navigate('/login');
      return;
    }

    const redirect = async () => {
      const stored = getEntityType() ?? 'restaurant';
      try {
        const profile = await fetchCompanyProfile(session.user.id, stored);
        saveEntityType(profile.entity_type);
        navigate(resolveEntityDashboardPath(profile.entity_type), { replace: true });
      } catch (err) {
        handleErrorApi(err, 'Impossible de charger le profil entreprise');
        navigate('/', { replace: true });
      }
    };

    redirect();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="text-center">
        <i className="ri-loader-4-line text-3xl text-teal-600 animate-spin mb-3 block" />
        <p className="text-slate-500 text-sm">Redirection vers votre espace…</p>
      </div>
    </div>
  );
}
